import { render, staticRenderFns } from "./activeAuthorizationsList.vue?vue&type=template&id=3eeecc2e"
import script from "./activeAuthorizationsList.js?vue&type=script&lang=js&external"
export * from "./activeAuthorizationsList.js?vue&type=script&lang=js&external"
import style0 from "./activeAuthorizationsList.vue?vue&type=style&index=0&id=3eeecc2e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports